import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Form } from "react-bootstrap";
import DropdownMain from "../../../../../../components/dropdown-main/DropdownMain";
import DisabledPlus from "../../../../../../assets/icons/Icon - Add - Disabled.svg";
import { TriyoForm } from "../../../../../../components/TriyoForm";
import { NIL as NIL_UUID } from "uuid";
import { WorkflowGrid } from "../../grid/workflow-grid";
import Select from "react-select";
import ReassignWorkflowPermission from "../reassign-workflow-permission";

const EditWorkflowActionModal = ({
  isActionModalOpen,
  setIsActionModalOpen,
  openWorkflowAction,
  workflowStatuses,
  workflowBaseStatuses,
  workflowActions,
  setWorkflowActions,
  workflowSystemActions,
  setWorkflowSystemActions,
  workflowBaseActions,
  setWorkflowBaseActions,
  customReminders,
  workflowBasic,
  setWorkflowBasic,
}) => {
  // Combine base and custom statuses for dropdown options
  const allWorkflowStatuses = [...(workflowBaseStatuses || []), ...(workflowStatuses || [])];
  const isArchiveAction = openWorkflowAction?.Name === "Archive" || openWorkflowAction?.Name === "Un-Archive";
  const [availableTime, setAvailableTime] = useState(false);
  const [availableCondition, setAvailableCondition] = useState(false);
  const [hideCondition, setHideCondition] = useState(false);
  const [dueDateExtension, setDueDateExtension] = useState(false);
  const [reminderExtension, setReminderExtension] = useState(false);
  const [availabilityUnits, setAvailabilityUnits] = useState(1);
  const [availabilityPeriod, setAvailabilityPeriod] = useState("Days");
  const [availabilityType, setAvailabilityType] = useState("After Start Date");
  const [availabilityTrigger, setAvailabilityTrigger] = useState("Manual");
  const [selectedWorkflowAction, setSelectedWorkflowAction] = useState([]);
  const [selectedIsEnableUndo, setSelectedIsEnableUndo] = useState(false);
  const [
    selectedWorkflowActionAvailability,
    setSelectedWorkflowActionAvailability,
  ] = useState([]);
  const availableOptionsAvailability = [
    "Owner",
    "Approvers",
    "Editors",
    "Viewers",
  ];

  const customWorkflowHelpers = {
    AvailabilityTypeValues: [
      { id: "After Start Date", name: "After Start Date" },
      { id: "Before Due Date", name: "Before Due Date" },
    ],
    AvailabilityIntervalTypeValues: [
      { id: "Days", name: "Days" },
      { id: "Business Days", name: "Business Days" },
    ],
  };

  useEffect(() => {
    if (openWorkflowAction.Id === undefined) {
      return;
    }
    if (
      openWorkflowAction.AvailableForStatus != null &&
      openWorkflowAction.AvailableForStatus != NIL_UUID
    ) {
      setAvailableCondition(true);
    }
    if (
      openWorkflowAction.HideForStatus != null &&
      openWorkflowAction.HideForStatus != NIL_UUID
    ) {
      setHideCondition(true);
    }
    if (
      openWorkflowAction.AvailableDaysAfterTaskStart != null &&
      openWorkflowAction.AvailableDaysAfterTaskStartType != null
    ) {
      setAvailableTime(true);
      setAvailabilityType("After Start Date");
      setAvailabilityPeriod(openWorkflowAction.AvailableDaysAfterTaskStartType);
    } else if (
      openWorkflowAction.AvailableDaysBeforeTaskDue != null &&
      openWorkflowAction.AvailableDaysBeforeTaskDueType != null
    ) {
      setAvailableTime(true);
      setAvailabilityType("Before Due Date");
      setAvailabilityPeriod(openWorkflowAction.AvailableDaysBeforeTaskDueType);
    }
    if (openWorkflowAction.DueDateExtensionType != null) {
      setDueDateExtension(true);
    }
    if (
      openWorkflowAction.ExtendByDaysMax != null &&
      openWorkflowAction.ExtendByDaysMax > 0
    ) {
      setReminderExtension(true);
    }
    if (
      //openWorkflowAction?.IsInitialStatus ||
      (openWorkflowAction?.AutomaticTriggers != "" &&
        openWorkflowAction.AutomaticTriggers != undefined)
    ) {
      setAvailabilityTrigger("Automatic");
    } else {
      setAvailabilityTrigger("Manual");
    }
    if (openWorkflowAction.AutomaticTriggers == undefined) {
      openWorkflowAction.AutomaticTriggers = "";
    }
    if (openWorkflowAction?.Name === "Re-assign Task") {
      openWorkflowAction.SelectedOwnerPermissions = JSON.parse(
        openWorkflowAction?.PermissionConditions
      )?.Owner;
      openWorkflowAction.SelectedApproverPermissions = JSON.parse(
        openWorkflowAction?.PermissionConditions
      )?.Approvers;
      openWorkflowAction.SelectedEditorPermissions = JSON.parse(
        openWorkflowAction?.PermissionConditions
      )?.Editors;
      openWorkflowAction.SelectedViewerPermissions = JSON.parse(
        openWorkflowAction?.PermissionConditions
      )?.Viewers;
    }
    if (openWorkflowAction.IsEnableUndo === false) {
      setSelectedIsEnableUndo(false);
    } else {
      setSelectedIsEnableUndo(true);
    }
    setSelectedWorkflowAction(openWorkflowAction);
    setSelectedWorkflowActionAvailability(openWorkflowAction.IsAvailableToList);
    setIsActionModalOpen(true);
  }, [openWorkflowAction]);

  const handleClose = () => {
    setSelectedWorkflowAction({});
    setIsActionModalOpen(false);
    setAvailableTime(false);
    setAvailableCondition(false);
    setHideCondition(false);
    setDueDateExtension(false);
    setReminderExtension(false);
    setSelectedIsEnableUndo(false);
    setAvailabilityTrigger("Manual");
    setSelectedWorkflowActionAvailability([]);
  };

  const addUpdateCurrentWorkflowStatus = () => {
    let workflowActionsTemp = [];
    if (selectedWorkflowAction.IsBase) {
      workflowActionsTemp = [...workflowBaseActions];
    } else if (selectedWorkflowAction.IsSystem) {
      workflowActionsTemp = [...workflowSystemActions];
    } else {
      workflowActionsTemp = [...workflowActions];
    }

    console.log("addUpdateCurrentWorkflowStatus =>");
    console.log("selectedWorkflowAction: ", selectedWorkflowAction);
    console.log("workflowActionsTemp: ", workflowActionsTemp);

    selectedWorkflowAction.IsAvailableToList =
      selectedWorkflowActionAvailability;
    let index = workflowActionsTemp.findIndex(
      (x) => x.Id === selectedWorkflowAction.Id
    );
    if (index > -1) {
      workflowActionsTemp[index] = selectedWorkflowAction;
    } else {
      workflowActionsTemp.push(selectedWorkflowAction);
    }
    if (
      selectedWorkflowAction?.AutomaticTriggers.includes("Task Creation")
      //&& !selectedWorkflowAction?.IsInitialStatus
    ) {
      selectedWorkflowAction.AutomaticTriggers =
        selectedWorkflowAction?.AutomaticTriggers?.split(",")
          .filter((trigger) => trigger != "Task Creation")
          .join(",");
      //selectedWorkflowAction.IsInitialStatus = true;
      workflowActionsTemp = workflowActionsTemp.map((status) => {
        if (status.Id == selectedWorkflowAction.Id) {
          return selectedWorkflowAction;
        } else {
          return { ...status };
        }
      });
      if (selectedWorkflowAction?.IsBase) {
        setWorkflowBaseActions(
          workflowBaseActions.map((status) => {
            return { ...status};
          })
        );
      } else if (selectedWorkflowAction?.IsSystem) {
        setWorkflowSystemActions(
          workflowSystemActions.map((status) => {
            return { ...status };
          })
        );
      } else {
        setWorkflowActions(
          workflowActions.map((status) => {
            return { ...status };
          })
        );
      }
      setWorkflowBasic({
        ...workflowBasic,
        InitialStatus: {
          id: selectedWorkflowAction.Name,
          name: selectedWorkflowAction.Name,
          isBase: selectedWorkflowAction.IsBase,
          isSystem: selectedWorkflowAction.IsSystem,
        },
      });
    }
    if (selectedWorkflowAction.IsBase) {
      setWorkflowBaseActions(workflowActionsTemp);
    } else if (selectedWorkflowAction.IsSystem) {
      setWorkflowSystemActions(workflowActionsTemp);
    } else {
      setWorkflowActions(workflowActionsTemp);
    }
    handleClose();
  };

  const setReassignPermissionConditions = (data) => {
    data.PermissionConditions = JSON.stringify({
      Owner: data.SelectedOwnerPermissions,
      Approvers: data.SelectedApproverPermissions,
      Editors: data.SelectedEditorPermissions,
      Viewers: data.SelectedViewerPermissions,
    });
    setSelectedWorkflowAction(data);
  };

  return (
    <Modal
      show={isActionModalOpen}
      className="workflow-modal-panel"
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Task Action</Modal.Title>
      </Modal.Header>

      <Modal.Body className="workflow-modal-body">
        {/* STATUS NAME */}
        <div className="workflow-modal-section">
          <img src={DisabledPlus} alt="Desabled Status name"></img>
          <Form.Control
            type="text"
            value={selectedWorkflowAction?.Name}
            onChange={(e) => {
              setSelectedWorkflowAction({
                ...selectedWorkflowAction,
                Name: e.target.value,
              });
            }}
            placeholder="Enter task action name"
            disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
          />
        </div>
        <hr className="divider"></hr>

        {/* STATUS DESCRIPTION */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Description</div>
            <div className="workflow-modal-description-subtitle">
              The description for the customized task action
            </div>
          </div>
          <div className="workflow-modal-input">
            <Form>
              <Form.Group className="description">
                <Form.Control
                  id="description"
                  name="description"
                  autoComplete="off"
                  placeholder="Describe how people should use this task"
                  className="project-textarea textarea"
                  value={selectedWorkflowAction?.Description}
                  onChange={(e) => {
                    setSelectedWorkflowAction({
                      ...selectedWorkflowAction,
                      Description: e.target.value,
                    });
                  }}
                  as="textarea"
                  rows="3"
                  disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
                />
              </Form.Group>
            </Form>
          </div>
        </div>
        <hr className="divider"></hr>

        {/* MAX INSTANCES */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Frequency</div>
            <div className="workflow-modal-description-subtitle">
              The number of times this task action will be used in the work
              flow. Set 0 for no limit.
            </div>
          </div>
          <div className="workflow-modal-input">
            <Form.Control
              type="number"
              value={selectedWorkflowAction?.MaxInstances}
              onChange={(e) => {
                setSelectedWorkflowAction({
                  ...selectedWorkflowAction,
                  MaxInstances: e.target.value,
                });
              }}
              placeholder=""
              disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
            />
          </div>
        </div>
        <hr className="divider"></hr>

        {/* AVAILABILITY */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Availability</div>
            <div className="workflow-modal-description-subtitle">
              Configure when the task action will be available in the task
              action menu.
            </div>
          </div>
          <div className="workflow-modal-input">
            <div>
              <div className="workflow-modal-description-title">
                This Task Action is triggered
              </div>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={availabilityTrigger == "Manual"}
                  onChange={() => {
                    setSelectedWorkflowAction({
                      ...selectedWorkflowAction,
                      Active: false,
                      AutomaticTriggers: "",
                    });
                    setAvailabilityTrigger("Manual");
                  }}
                  disabled={isArchiveAction}
                />
                Manually
              </label>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={availabilityTrigger == "Automatic"}
                  onChange={() => {
                    setSelectedWorkflowAction({
                      ...selectedWorkflowAction,
                      Active: true,
                    });
                    setAvailabilityTrigger("Automatic");
                  }}
                  disabled={
                    isArchiveAction ||
                    ((selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem) &&
                    selectedWorkflowAction?.Name == "Re-assign Task")
                  }
                />
                Automatically
              </label>
            </div>
            {availabilityTrigger == "Manual" ? (
              <div>
                <div className="greyText mb-4">
                  When a Task Action is set to be to be triggered Manually,
                  Assigned Members for the Task will be able to select it from
                  the Actions Overflow menu to apply the associated Automations.
                </div>
                <div className="available-section">
                  {/* AVAILABLE TIME  */}
                  <div className="available-time">
                    <div className="workflow-modal-description">
                      <div className="workflow-modal-description-title">
                        Set Available Time
                      </div>
                      <div className="workflow-modal-description-subtitle">
                        Enabling this toggle will allow you to set the available
                        time for this task action.
                      </div>
                    </div>

                    <TriyoForm.Toggle
                      checked={availableTime}
                      onChange={() => {
                        if (!availableTime) {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            AvailableDaysAfterTaskStart: 1,
                            AvailableDaysAfterTaskStartType: "Days",
                          });
                          setAvailabilityPeriod("Days");
                          setAvailabilityType("After Start Date");
                          setAvailabilityUnits(1);
                        } else {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            AvailableDaysBeforeTaskDue: null,
                            AvailableDaysBeforeTaskDueType: null,
                            AvailableDaysAfterTaskStart: null,
                            AvailableDaysAfterTaskStartType: null,
                          });
                        }
                        setAvailableTime(!availableTime);
                      }}
                    />
                  </div>
                  {availableTime && (
                    <div className="available-time-options">
                      <div className="availabilityUnits">
                        <input
                          value={
                            selectedWorkflowAction?.AvailableDaysAfterTaskStart ??
                            selectedWorkflowAction?.AvailableDaysBeforeTaskDue
                          }
                          type="number"
                          min={1}
                          required
                          onKeyDown={(e) => {
                            (e.key === "Enter" ||
                              e.key === "." ||
                              e.key === "-") &&
                              e.preventDefault();
                          }}
                          onBlur={(e) => {
                            if (e.target.value == 0) {
                              e.target.value = 1;
                            }
                          }}
                          onChange={(e) => {
                            e.target.value =
                              e.target.value == 0 ? 1 : e.target.value;
                            if (availabilityType == "After Start Date") {
                              setSelectedWorkflowAction({
                                ...selectedWorkflowAction,
                                AvailableDaysAfterTaskStart: e.target.value,
                                AvailableDaysBeforeTaskDue: null,
                              });
                            } else {
                              setSelectedWorkflowAction({
                                ...selectedWorkflowAction,
                                AvailableDaysBeforeTaskDue: e.target.value,
                                AvailableDaysAfterTaskStart: null,
                              });
                            }
                            setAvailabilityUnits(e.target.value);
                          }}
                        />
                      </div>
                      <div className="availabilityPeriod">
                        <div className="row-dropdown">
                          <DropdownMain
                            values={
                              customWorkflowHelpers.AvailabilityIntervalTypeValues
                            }
                            dropdownButtonText={"-Select-"}
                            onSelect={(selectedValue) => {
                              if (availabilityType == "After Start Date") {
                                setSelectedWorkflowAction({
                                  ...selectedWorkflowAction,
                                  AvailableDaysAfterTaskStartType:
                                    selectedValue.name,
                                });
                              } else {
                                setSelectedWorkflowAction({
                                  ...selectedWorkflowAction,
                                  AvailableDaysBeforeTaskDueType:
                                    selectedValue.name,
                                });
                              }
                              setAvailabilityPeriod(selectedValue.name);
                            }}
                            currentSelected={{ name: availabilityPeriod }}
                            additonalClasses={
                              "overflowSetAbsolute dropdown-custom-reminders"
                            }
                            alignRight={true}
                          />
                        </div>
                      </div>
                      <td className="availabilityType">
                        <div className="reminder-dropdown">
                          <DropdownMain
                            values={
                              customWorkflowHelpers.AvailabilityTypeValues
                            }
                            dropdownButtonText={"-Select-"}
                            onSelect={(selectedValue) => {
                              if (availabilityType != selectedValue.name) {
                                if (selectedValue.name == "After Start Date") {
                                  setSelectedWorkflowAction({
                                    ...selectedWorkflowAction,
                                    AvailableDaysAfterTaskStartType:
                                      availabilityPeriod,
                                    AvailableDaysAfterTaskStart:
                                      availabilityUnits,
                                  });
                                } else {
                                  setSelectedWorkflowAction({
                                    ...selectedWorkflowAction,
                                    AvailableDaysBeforeTaskDueType:
                                      availabilityPeriod,
                                    AvailableDaysBeforeTaskDue:
                                      availabilityUnits,
                                  });
                                }
                              }
                              setAvailabilityType(selectedValue.name);
                            }}
                            currentSelected={{ name: availabilityType }}
                            additonalClasses={"overflowSetAbsolute"}
                            alignRight={true}
                          />
                        </div>
                      </td>
                    </div>
                  )}

                  {/* AVAILABLE CONDITION */}
                  <div className="available-time">
                    <div className="workflow-modal-description">
                      <div className="workflow-modal-description-title">
                        Set Available Condition
                      </div>
                      <div className="workflow-modal-description-subtitle">
                        Enabling this toggle will allow you to set the available
                        condition for this task action. The task action will
                        only be available for the selected task status.
                      </div>
                    </div>

                    <TriyoForm.Toggle
                      onChange={() => {
                        if (availableCondition) {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            AvailableForStatus: NIL_UUID,
                          });
                        }
                        setAvailableCondition(!availableCondition);
                      }}
                      checked={availableCondition}
                    />
                  </div>
                  {availableCondition && (
                    <div className="available-time-options">
                      <DropdownMain
                        values={
                          allWorkflowStatuses
                            .filter((options) => {
                              if (options.IsHidden) return false;
                              // Exclude current action and the status already selected as unavailable
                              if (options.Id === selectedWorkflowAction?.Id) return false;
                              if (options.Id === selectedWorkflowAction?.HideForStatus) return false;
                              return true;
                            })
                            .map((options) => {
                              return { id: options.Id, name: options.Name };
                            })
                        }
                        dropdownButtonText={"Select an existing task status"}
                        onSelect={(selectedValue) => {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            AvailableForStatus: selectedValue.id,
                          });
                        }}
                        currentSelected={
                          selectedWorkflowAction?.AvailableForStatus != NIL_UUID
                            ? { id: selectedWorkflowAction?.AvailableForStatus }
                            : null
                        }
                      />
                    </div>
                  )}

                  {/* UNAVAILABLE CONDITION */}
                  <div className="available-time">
                    <div className="workflow-modal-description">
                      <div className="workflow-modal-description-title">
                        Set Unavailable Condition
                      </div>
                      <div className="workflow-modal-description-subtitle">
                        Enabling this toggle will allow you to set the
                        unavailable condition for this task action. The task
                        action will not be available for the selected task
                        status.
                      </div>
                    </div>

                    <TriyoForm.Toggle
                      onChange={() => {
                        if (hideCondition) {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            HideForStatus: NIL_UUID,
                          });
                        }
                        setHideCondition(!hideCondition);
                      }}
                      checked={hideCondition}
                    />
                  </div>
                  {hideCondition && (
                    <div className="available-time-options">
                      <DropdownMain
                        values={
                          allWorkflowStatuses
                            .filter((options) => {
                              // Exclude current action and the status already selected as available
                              if (options.IsHidden) return false;
                              if (options.Id === selectedWorkflowAction?.Id) return false;
                              if (options.Id === selectedWorkflowAction?.AvailableForStatus) return false;
                              return true;
                            })
                            .map((options) => {
                              return { id: options.Id, name: options.Name };
                            })
                        }
                        dropdownButtonText={"Select an existing task status"}
                        onSelect={(selectedValue) => {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            HideForStatus: selectedValue.id,
                          });
                        }}
                        currentSelected={
                          selectedWorkflowAction?.HideForStatus != NIL_UUID
                            ? { id: selectedWorkflowAction?.HideForStatus }
                            : null
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div className="greyText mb-4">
                  When a Task Action is set to be triggered Automatically, this
                  Task Action and associated Automations will be applied when
                  certain events occur during the Task Workflow. Please select
                  what events trigger this Task Action from the list below.
                </div>
                <div>
                  <TriyoForm.Checkboxes
                    className="availabilityCheckBoxes"
                    lookupValues={[
                      "Task Creation",
                      "Task Updates",
                      "Internal Email Responses",
                      "External Email Responses",
                      "Task Comments",
                      "Re-Assigned",
                    ]}
                    value={selectedWorkflowAction?.AutomaticTriggers}
                    onChange={(e) => {
                      setSelectedWorkflowAction({
                        ...selectedWorkflowAction,
                        AutomaticTriggers: e,
                      });
                    }}
                    disabledChecked={
                      selectedWorkflowAction?.IsInitialStatus
                        ? "Task Creation"
                        : ""
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <hr className="divider"></hr>

        {/* PERMISSIONS */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Permission</div>
          </div>
          <div className="workflow-modal-input">
            <div className="workflow-modal-description-title mb-3">
              Select who has access to this task action
            </div>
            <Select
              isMulti
              options={availableOptionsAvailability.map((value) => ({
                value,
                label: value,
              }))}
              value={
                selectedWorkflowActionAvailability != null &&
                selectedWorkflowActionAvailability.map((status) => ({
                  value: status,
                  label: status,
                }))
              }
              onChange={(selected) =>
                setSelectedWorkflowActionAvailability(
                  selected ? selected.map((option) => option.value) : []
                )
              }
              placeholder="Select workflow roles"
            />
            <div className="mb-3"></div>
            {!(selectedWorkflowAction?.IsSelfAssign ||
              selectedWorkflowAction?.IsBase) && (
              <div>
                <div className="workflow-modal-description-title ">
                  Enable Undo
                </div>
                <label className="workflow-radio">
                  <input
                    className={"filter-panel-dropdown-members-radio-button"}
                    type="radio"
                    checked={selectedWorkflowAction?.IsEnableUndo}
                    onChange={() => {
                      setSelectedWorkflowAction({
                        ...selectedWorkflowAction,
                        IsEnableUndo: true,
                      });
                    }}
                    disabled={isArchiveAction}
                  />
                  Yes
                </label>
                <label className="workflow-radio">
                  <input
                    className={"filter-panel-dropdown-members-radio-button"}
                    type="radio"
                    checked={!selectedWorkflowAction?.IsEnableUndo}
                    onChange={() => {
                      setSelectedWorkflowAction({
                        ...selectedWorkflowAction,
                        IsEnableUndo: false,
                      });
                    }}
                    disabled={isArchiveAction}
                  />
                  No
                </label>
              </div>
            )}
          </div>
        </div>
        <hr className="divider"></hr>

        {/* AUTOMATION  */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Automation</div>
            <div className="workflow-modal-description-subtitle">
              Configure events that will be triggered by the task action.
            </div>
          </div>
          <div className="workflow-modal-input ">
            {/* PROJECT COMPLETE */}
            <div>
              <div className="workflow-modal-description-title mb-3">
                What task status will this task action lead to?
              </div>
              <div>
                <Form>
                  <Form.Group className="description">
                    <Form.Control
                      type="text"
                      id="actionstatus"
                      name="actionstatus"
                      autoComplete="off"
                      placeholder="The name of the action status displayed in the Status column of the task list."
                      value={selectedWorkflowAction?.ActionStatus}
                      onChange={(e) => {
                        setSelectedWorkflowAction({
                          ...selectedWorkflowAction,
                          ActionStatus: e.target.value,
                        });
                      }}
                      disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
                    />
                  </Form.Group>
                </Form>
              </div>
              <div className="workflow-modal-description-title">
                Will the task be completed after this task action?
              </div>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={!selectedWorkflowAction?.Active}
                  onChange={() => {
                    setSelectedWorkflowAction({
                      ...selectedWorkflowAction,
                      Active: false,
                    });
                  }}
                  disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
                />
                Yes
              </label>
              <label className="workflow-radio">
                <input
                  className={"filter-panel-dropdown-members-radio-button"}
                  type="radio"
                  checked={selectedWorkflowAction?.Active}
                  onChange={() => {
                    setSelectedWorkflowAction({
                      ...selectedWorkflowAction,
                      Active: true,
                    });
                  }}
                  disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
                />
                No
              </label>
            </div>
            {/* DUE DATE EXTENSION  */}
            <div className="available-section">
              <div className="available-time">
                <div className="workflow-modal-description">
                  <div className="workflow-modal-description-title">
                    Enable Task Due Date Extension
                  </div>
                  <div className="workflow-modal-description-subtitle">
                    Enabling this toggle will give you the option to extend the
                    task due date when performing this task action.
                  </div>
                </div>

                <TriyoForm.Toggle
                  onChange={() => {
                    if (dueDateExtension) {
                      setSelectedWorkflowAction({
                        ...selectedWorkflowAction,
                        DueDateExtensionDefault: null,
                        DueDateExtensionType: null,
                        DueDateExtendProject: null,
                        DueDateExtension: null,
                      });
                    } else {
                      setSelectedWorkflowAction({
                        ...selectedWorkflowAction,
                        DueDateExtensionDefault: 1,
                        DueDateExtensionType: "Days",
                        DueDateExtendProject: true,
                        DueDateExtension: true,
                      });
                    }
                    setDueDateExtension(!dueDateExtension);
                  }}
                  checked={dueDateExtension}
                  disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
                />
              </div>
              { dueDateExtension &&
                <div className="extension">
                  <div className="extension-text">
                    Extend the Task Due Date by
                  </div>
                  <div className="available-time-options">
                    <div className="availabilityUnits dueDateExtension">
                      <input
                        value={
                          selectedWorkflowAction?.DueDateExtensionDefault == 0
                            ? 1
                            : selectedWorkflowAction?.DueDateExtensionDefault
                        }
                        type="number"
                        min={1}
                        required
                        onKeyDown={(e) => {
                          (e.key === "Enter" ||
                            e.key === "." ||
                            e.key === "-") &&
                            e.preventDefault();
                        }}
                        onBlur={(e) => {
                          if (e.target.value == 0) {
                            e.target.value = 1;
                          }
                        }}
                        onChange={(e) => {
                          e.target.value =
                            e.target.value == 0 ? 1 : e.target.value;
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            DueDateExtensionDefault: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="availabilityPeriod dueDateExtension">
                      <div className="row-dropdown">
                        <DropdownMain
                          values={
                            customWorkflowHelpers.AvailabilityIntervalTypeValues
                          }
                          dropdownButtonText={"-Select-"}
                          onSelect={(selectedValue) => {
                            setSelectedWorkflowAction({
                              ...selectedWorkflowAction,
                              DueDateExtensionType: selectedValue.name,
                            });
                          }}
                          currentSelected={
                            selectedWorkflowAction?.DueDateExtensionType == null
                              ? { name: "Days" }
                              : {
                                  name: selectedWorkflowAction?.DueDateExtensionType,
                                }
                          }
                          additonalClasses={
                            "overflowSetAbsolute dropdown-custom-reminders"
                          }
                          alignRight={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="workflow-project-extend">
                    <span>
                      What would you like to happen to the Project Due Date?
                    </span>
                    <div className="workflow-radio">
                      <input
                        className={"filter-panel-dropdown-members-radio-button"}
                        type="radio"
                        checked={selectedWorkflowAction?.DueDateExtendProject}
                        onChange={() => {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            DueDateExtendProject: true,
                          });
                        }}
                      />
                      Also extend project due date
                    </div>
                    <div className="workflow-radio">
                      <input
                        className={"filter-panel-dropdown-members-radio-button"}
                        type="radio"
                        checked={!selectedWorkflowAction?.DueDateExtendProject}
                        onChange={() => {
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            DueDateExtendProject: false,
                          });
                        }}
                      />
                      Do not extend project due date
                    </div>
                  </div>
                </div>
              }
            </div>
            {/* REMNINDER EXTENSION  */}
            <div className="available-section">
              <div className="available-time">
                <div className="workflow-modal-description">
                  <div className="workflow-modal-description-title">
                    Enable Task Reminder Extension
                  </div>
                  <div className="workflow-modal-description-subtitle">
                    Enabling this toggle will give you the option to extend a
                    task reminder when performing this task action.
                  </div>
                </div>

                <TriyoForm.Toggle
                  onChange={() => {
                    if (reminderExtension) {
                      setSelectedWorkflowAction({
                        ...selectedWorkflowAction,
                        ExtendByDaysMax: null,
                        ExtendReminderName: null,
                      });
                    } else {
                      setSelectedWorkflowAction({
                        ...selectedWorkflowAction,
                        ExtendByDaysMax: 1,
                      });
                    }
                    setReminderExtension(!reminderExtension);
                  }}
                  checked={reminderExtension}
                  disabled={selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem}
                />
              </div>
              { reminderExtension &&
                <div className="extension">
                  <div className="available-time-options-headings">
                    <div className="availabilityUnits extension-text">
                      Max Business Days the Reminder can be Extended by
                    </div>
                    <div className="availabilityUnits extension-text">
                      Reminder Name
                    </div>
                  </div>
                  <div className="available-time-options">
                    <div className="availabilityUnits dueDateExtension">
                      <input
                        value={
                          selectedWorkflowAction?.ExtendByDaysMax == 0
                            ? 1
                            : selectedWorkflowAction?.ExtendByDaysMax
                        }
                        type="number"
                        min={1}
                        required
                        onKeyDown={(e) => {
                          (e.key === "Enter" ||
                            e.key === "." ||
                            e.key === "-") &&
                            e.preventDefault();
                        }}
                        onBlur={(e) => {
                          if (e.target.value == 0) {
                            e.target.value = 1;
                          }
                        }}
                        onChange={(e) => {
                          e.target.value =
                            e.target.value == 0 ? 1 : e.target.value;
                          setSelectedWorkflowAction({
                            ...selectedWorkflowAction,
                            ExtendByDaysMax: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <DropdownMain
                      values={
                        customReminders &&
                        customReminders.map((options) => {
                          return { id: options.Name, name: options.Name };
                        })
                      }
                      dropdownButtonText={"Select a custom task reminder"}
                      onSelect={(selectedValue) => {
                        setSelectedWorkflowAction({
                          ...selectedWorkflowAction,
                          ExtendReminderName: selectedValue.id,
                        });
                      }}
                      currentSelected={
                        selectedWorkflowAction?.ExtendReminderName != null
                          ? { id: selectedWorkflowAction?.ExtendReminderName }
                          : null
                      }
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <hr className="divider"></hr>

        {/* CONDITIONS  */}
        <div className="workflow-modal-section">
          <div className="workflow-modal-description">
            <div className="workflow-modal-description-title">Custom Rules</div>
            <div className="workflow-modal-description-subtitle">
              Configure specific conditions.
            </div>
          </div>
          <div className="workflow-modal-input ">
            { selectedWorkflowAction?.Name == "Re-assign Task" &&
              (selectedWorkflowAction?.IsBase || selectedWorkflowAction?.IsSystem)
                ? <ReassignWorkflowPermission
                    data={selectedWorkflowAction}
                    setData={setReassignPermissionConditions}
                    availableOptionsAvailability={availableOptionsAvailability}
                  />
                : <div>
                    <WorkflowGrid
                      workflowActionId={selectedWorkflowAction.Id}
                      type={"form-visibility"}
                      name={"Form Conditions (Available)"}
                    />
                    <hr />
                    <WorkflowGrid
                      workflowActionId={selectedWorkflowAction.Id}
                      type={"form-availability"}
                      name={"Form Conditions (Hidden)"}
                    />
                    <hr />
                    <WorkflowGrid
                      workflowActionId={selectedWorkflowAction.Id}
                      type={"field"}
                      name={"Field Conditions"}
                    />
                  </div>
            }
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn btn-setting-light btn-sm" onClick={handleClose}>
          Close
        </Button>
        <Button
          className="btn btn-setting-primary btn-sm"
          onClick={addUpdateCurrentWorkflowStatus}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const actionShape = PropTypes.shape({
  Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  Name: PropTypes.string,
  Description: PropTypes.string,

  // Availability / visibility conditions
  AvailableForStatus: PropTypes.string,
  HideForStatus: PropTypes.string,
  IsAvailableToList: PropTypes.arrayOf(PropTypes.string),

  // Time-based availability
  AvailableDaysAfterTaskStart: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  AvailableDaysAfterTaskStartType: PropTypes.string,
  AvailableDaysBeforeTaskDue: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  AvailableDaysBeforeTaskDueType: PropTypes.string,

  // Triggering
  AutomaticTriggers: PropTypes.string, // CSV string (e.g., "Task Creation,Task Updates")

  // Action meta
  MaxInstances: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ActionStatus: PropTypes.string,
  Active: PropTypes.bool,

  // Flags
  IsBase: PropTypes.bool,
  IsInitialStatus: PropTypes.bool,
  IsSelfAssign: PropTypes.bool,
  IsEnableUndo: PropTypes.bool,

  // Due date extension
  DueDateExtensionDefault: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  DueDateExtensionType: PropTypes.string,
  DueDateExtendProject: PropTypes.bool,
  DueDateExtension: PropTypes.bool,

  // Reminder extension
  ExtendByDaysMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ExtendReminderName: PropTypes.string,

  // Re-assign Task permissions (when applicable)
  PermissionConditions: PropTypes.string, // JSON string
  SelectedOwnerPermissions: PropTypes.arrayOf(PropTypes.string),
  SelectedApproverPermissions: PropTypes.arrayOf(PropTypes.string),
  SelectedEditorPermissions: PropTypes.arrayOf(PropTypes.string),
  SelectedViewerPermissions: PropTypes.arrayOf(PropTypes.string),
});

const reminderShape = PropTypes.shape({
  Name: PropTypes.string.isRequired,
});

const initialStatusShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  isBase: PropTypes.bool,
});

const statusShape = PropTypes.shape({
  Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  Name: PropTypes.string,
  IsBase: PropTypes.bool,
  Active: PropTypes.bool,
});

EditWorkflowActionModal.propTypes = {
  isActionModalOpen: PropTypes.bool.isRequired,
  setIsActionModalOpen: PropTypes.func.isRequired,

  openWorkflowAction: actionShape.isRequired,

  workflowStatuses: PropTypes.arrayOf(statusShape),
  workflowBaseStatuses: PropTypes.arrayOf(statusShape),

  workflowActions: PropTypes.arrayOf(actionShape).isRequired,
  setWorkflowActions: PropTypes.func.isRequired,

  workflowSystemActions: PropTypes.arrayOf(actionShape).isRequired,
  setWorkflowSystemActions: PropTypes.func.isRequired,

  workflowBaseActions: PropTypes.arrayOf(actionShape).isRequired,
  setWorkflowBaseActions: PropTypes.func.isRequired,

  customReminders: PropTypes.arrayOf(reminderShape),

  workflowBasic: PropTypes.shape({
    InitialStatus: initialStatusShape,
  }).isRequired,
  setWorkflowBasic: PropTypes.func.isRequired,
};

EditWorkflowActionModal.defaultProps = {
  customReminders: [],
  workflowStatuses: [],
  workflowBaseStatuses: [],
};

export default EditWorkflowActionModal;
